import 'dayjs/locale/da';
import { Settings } from 'luxon';

import ReactDOM from 'react-dom/client';

import '@fontsource/sora/400.css';
import '@fontsource/sora/500.css';
import '@fontsource/sora/600.css';
import '@fontsource/sora/700.css';

import '@mantine/charts/styles.css';
import '@mantine/core/styles.css';
import { DatesProvider } from '@mantine/dates';
import '@mantine/dates/styles.css';
import '@mantine/dropzone/styles.css';
import { Notifications } from '@mantine/notifications';
import '@mantine/notifications/styles.css';
import '@mantine/spotlight/styles.css';
import '@mantine/tiptap/styles.css';

import 'mantine-datatable/styles.layer.css';

import { RouterProvider, createRouter } from '@tanstack/react-router';

import { MantineProvider, optiroTheme } from '@optiro/ui';

import { AnalyticsConsent } from '@/components/AnalyticsConsent';
import { initAnalytics, trackRouterPageviews } from '@/modules/Analytics';
import { hasSentryReplayConsent, initSentry, initSentryReplay } from '@/lib/sentry';

import './i18n';
import './index.css';
import { routeTree } from './routeTree.gen';

initSentry();
if (hasSentryReplayConsent()) initSentryReplay();

initAnalytics();

const router = createRouter({ routeTree });
trackRouterPageviews(router);

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// Set Luxon to use Danish locale globally
Settings.defaultLocale = 'da';
Settings.defaultZone = 'Europe/Copenhagen'; // Optional: set default timezone

const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <MantineProvider theme={optiroTheme} defaultColorScheme="light">
      <DatesProvider settings={{ locale: 'da' }}>
        <Notifications />
        <AnalyticsConsent />
        <RouterProvider router={router} />
      </DatesProvider>
    </MantineProvider>
  );
}
